export default "__VITE_ASSET__C5Mfcd39__"